import { request } from '@umijs/max';
import { DEFAULT_CONSOLE_PORTAL_APP_CODE } from '@/constants/appCode';
import { getAdminApiUrl } from '@/services/util';

export type MenuOpenMode = 'internal' | 'blank' | 'iframe';

/** 用户菜单树节点 */
export interface UserMenuTreeItem {
  menuId: string;
  appCode?: string;
  name: string;
  code: string;
  sortOrder: number;
  parentId: string;
  description?: string;
  icon?: string;
  openMode?: MenuOpenMode;
  path?: string;
  visible?: boolean;
  children?: UserMenuTreeItem[];
}

export interface UserMenuTreeResponse {
  tree: UserMenuTreeItem[];
}

export function extractUserMenuTree(response: unknown): UserMenuTreeItem[] {
  if (!response) {
    return [];
  }
  if (Array.isArray(response)) {
    return response as UserMenuTreeItem[];
  }
  if (typeof response !== 'object') {
    return [];
  }
  const record = response as Record<string, unknown>;
  if (Array.isArray(record.tree)) {
    return record.tree as UserMenuTreeItem[];
  }
  if (record.data && typeof record.data === 'object') {
    const data = record.data as Record<string, unknown>;
    if (Array.isArray(data.tree)) {
      return data.tree as UserMenuTreeItem[];
    }
  }
  return [];
}

/** 当前用户可访问的菜单树 */
export async function getUserMenuTree(
  options?: { [key: string]: unknown },
) {
  const response = await request<UserMenuTreeResponse | UserMenuTreeItem[]>(
    getAdminApiUrl('menu/user-tree'),
    {
      method: 'POST',
      data: {
        appCode: DEFAULT_CONSOLE_PORTAL_APP_CODE,
      },
      ...(options || {}),
    },
  );
  return { tree: extractUserMenuTree(response) };
}
